/**
 * Bandeau d’erreur d’API.
 *
 * Affiche **uniquement** une clé `ui:errors.*` : le message français renvoyé par le serveur
 * reste dans les journaux (DECISIONS §9.4). `role="alert"` fait annoncer l’erreur dès son
 * apparition.
 */
import { useTranslation } from 'react-i18next';

import { cleI18nErreur, type ErreurApi } from '../api';
import { Bouton } from './Bouton';

export interface ProprietesBandeauErreur {
  readonly erreur: ErreurApi;
  /** Fourni quand l’action peut être rejouée sans risque. */
  readonly surReessai?: () => void;
}

export function BandeauErreur({ erreur, surReessai }: ProprietesBandeauErreur) {
  const { t } = useTranslation();
  return (
    <div className="bandeau-erreur" role="alert">
      <p className="bandeau-erreur__message">{t(cleI18nErreur(erreur))}</p>
      {surReessai === undefined ? null : (
        <Bouton variante="secondaire" onClick={surReessai}>
          {t('commun.reessayer')}
        </Bouton>
      )}
    </div>
  );
}
